import { Component, OnInit } from "@angular/core";
import { TranslocoService } from "@jsverse/transloco";
import { NgxSpinnerService } from "ngx-spinner";
import { ConfirmationService, SelectItem } from "primeng/api";
import { NotificationTypes } from "src/app/app.enums";
import { Events } from "src/app/models/emailevents.model";
import { AuthConfig, AuthService, EmailEventsFilters } from "src/app/Services/auth.service";
import { EmailEventTypeService } from "src/app/Services/email-event-type.service";
import { NotificationsService } from "src/app/Services/shared/notifications.service";

@Component({
    selector: 'email-events',
    templateUrl: './email-events.component.html',
    styleUrls: ['./email-events.component.css'],
    standalone: false
})

export class EmailEventComponent implements OnInit{
    public isEditMode: boolean = false;
    public loading: boolean = true;
    public isAddEmailEventDailogVisible: boolean = false;
    public emailEvents: Events[] = [];
    public emailParameters: SelectItem[] = [];
    public selectedEmailParameters: SelectItem[] = [];
    public emailEventsFormData!: Events;
    public authConfig: AuthConfig = {};

    constructor(
        private ngxSpinnerService: NgxSpinnerService,
        private notificationsService: NotificationsService,
        private emailEventTypeService: EmailEventTypeService,
        private authService: AuthService,
        private confirmationService: ConfirmationService,
        private transloco: TranslocoService){
        this.emailEventsFormData = new Events();
    }

    ngOnInit(): void {
        this.authConfig = this.authService.getAuthConfig();
        if (this.authConfig.IsSuperAdmin || this.authConfig.IsAdministrator) {
            this.getEmailEvents();
            this.getEmailParameters();
        }
    }

    public getEmailEvents() {
        this.loading = true;
        this.ngxSpinnerService.show();
        this.emailEventTypeService.fetchEmailevents(EmailEventsFilters.All).subscribe(
          (EmailEvents: Events[]) => {
            console.log(EmailEvents)
            this.emailEvents = EmailEvents
            this.ngxSpinnerService.hide();
            this.loading = false;
          },
          (error) => {
            console.error(error);
            this.ngxSpinnerService.hide();
            this.loading = false;
          }
        );
    }

    public getEmailParameters(){
        this.emailEventTypeService.fetchEmailParameters().subscribe((emailParameters) => {
            this.emailParameters = emailParameters.map((item) => {
              return { label: item.ParameterName, value: item.Guid };
            });
            console.log('emailParameters: ', this.emailParameters);
        },(error) => {console.error(error);});
    }
    

    public editEmailEvent(id: string){
        const currentEmailEvent = this.emailEvents.find((p) => p.Id == id);
        console.log(currentEmailEvent)
        if(currentEmailEvent){
            this.selectedEmailParameters = this.emailParameters
            .filter(param => currentEmailEvent.EmailParameterIds.includes(param.value))
            console.log(this.selectedEmailParameters)
            this.emailEventsFormData = { ...currentEmailEvent };
          this.isEditMode = true;
          this.isAddEmailEventDailogVisible = true
        }
    }

    public onShowEmailEventsDialog(){
        this.isEditMode = false
        this.isAddEmailEventDailogVisible = true
    }

    public onEventParametersChange($event: any){
       this.emailEventsFormData.EmailParameterIds = $event.value.map((p: { value: any; }) => p.value);
    }

    // public onCloseEmailEventsDialog(){
    //     this.isAddEmailEventDailogVisible = false
    //     this.emailEventsFormData = new EmailEvents();
    //     this.selectedEmailParameters = []
    // }

    public onCloseEmailEventsDialog($event: boolean){
        this.emailEventsFormData = new Events();
        this.selectedEmailParameters = []
        this.isAddEmailEventDailogVisible = $event
    }

    public onDeleteEmailEvent(id: string){
        const emailEvent = this.emailEvents.find((emailEvent)=>emailEvent.Id === id)
        this.confirmationService.confirm({
        message: this.transloco.translate('emailEvents.confirmDelete', { name: emailEvent?.Name }),
        accept: () => {
            this.ngxSpinnerService.show();
            this.emailEventTypeService.deleteEmailEvent(id).subscribe((response) => {
                if (response.Success) {
                    this.ngxSpinnerService.hide();
                    this.notificationsService.showNotification(this.transloco.translate('emailEvents.success'),response.ResponseMessage,NotificationTypes.Success);
                    var index = this.emailEvents.findIndex((emailEvent) => emailEvent.Id == id);
                    if (index >= 0) {
                        this.emailEvents.splice(index, 1);
                        this.getEmailEvents();
                    }
                } else {
                    this.ngxSpinnerService.hide();
                    this.notificationsService.showNotification(this.transloco.translate('emailEvents.error'),response.ResponseMessage,NotificationTypes.Error);
                }
            },(error) => {console.error(error);this.ngxSpinnerService.hide();});
        },
        });
    }

}